import { HttpEvent as AngularHttpEvent, HttpEventType } from '@angular/common/http';
import { PreserveNumberAlias, PreserveStringAlias } from 'src/app/utils/alias.utils';

export type MSUrl = string & PreserveStringAlias;
export type MSBaseUrl = string & PreserveStringAlias;
export type MSEndpoint = string & PreserveStringAlias;
export type MSServerResponseCode = number & PreserveNumberAlias;

export type MSQuery = {
  [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
};

export type MSBody = {
  [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> | MSBody;
};

export const MSClientNoServerAddressCached: MSServerResponseCode = 1;
export const MSServerOkResponse: MSServerResponseCode = 200;
export const MSServerMultipleChoicesResponse: MSServerResponseCode = 300;
export const MSUpgradeRequiredResponse: MSServerResponseCode = 426;
export const MSInternalServerError: MSServerResponseCode = 500;

export namespace MSHttpEvent {
  abstract class Base {}

  export class Success extends Base {
    constructor(
      readonly status: number,
      readonly data: Object
    ) {
      super();
    }
  }

  export class Error extends Base {
    constructor(
      readonly status: number,
      readonly error: string
    ) {
      super();
    }
  }

  export class Loading extends Base {}

  export type Spec = Success | Error | Loading;
}

const LoadingTypes = [HttpEventType.Sent, HttpEventType.UploadProgress, HttpEventType.DownloadProgress, HttpEventType.ResponseHeader];

export function angularHttpEventToMSHttpEvent(event: AngularHttpEvent<Object>): MSHttpEvent.Spec {
  if (LoadingTypes.includes(event.type)) {
    return new MSHttpEvent.Loading();
  } else if (event.type === HttpEventType.Response) {
    if (event.status >= MSServerOkResponse && event.status < MSServerMultipleChoicesResponse) {
      return new MSHttpEvent.Success(event.status, event.body);
    } else {
      return new MSHttpEvent.Error(event.status, event.statusText);
    }
  } else {
    throw new Error(`Unknown event type: ${event.type}`);
  }
}
